export default __webpack_public_path__ + "static/media/TDPS_PORTAL_TradeUpload.8e7146d3.xlsx";